import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { LabeledValue } from '../../../../../../controls/labeled-value';
import { State } from '../../../../../../redux/root-reducer';
import { getFormDetails } from '../../form-details-reducer';
import { FormDetails } from '../../form-details-reducer';
import { OpenModal, openModalAction } from '../../../../../../form-modal/actions';
import { getClaim } from '../../../../../../claim';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const ClaimantDetailsViewComponent: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    claimType,
}: Props) => {
    const claimantContactDetails = formDetails?.claimant?.contactDetails || {};
    const claimantPersonalDetails = formDetails?.claimant?.personalDetails || {};
    const claimantDetails = formDetails?.claimant?.claimantDetails || {};

    let header = 'Contact person for claim';
    if (claimType === ClaimType.Disability || claimType === ClaimType.Retrenchment) {
        header = 'Claimant Details';
    }

    let title;
    if (claimantDetails.title) {
        title =
            claimantDetails.title.charAt(0).toUpperCase() +
            claimantDetails.title.slice(1).toLowerCase();
    }
    return (
        <ExpansionPanel name="Claimant details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <Grid container justify="space-between" className={classes.marginTop2}>
                    <Grid container item xs={10} alignItems="center">
                        <Typography
                            style={{ padding: 10 }}
                            className={classes.heading}
                            variant="body1"
                        >
                            {header}
                        </Typography>
                    </Grid>
                </Grid>
                {!(claimType === ClaimType.Disability || claimType === ClaimType.Retrenchment) && (
                    <Paper className={classes.paper}>
                        <Grid container justify="flex-start">
                            <Grid item xs={12} container justify="flex-start">
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Title"
                                        value={claimantPersonalDetails.title}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="First Name"
                                        value={claimantPersonalDetails.firstName}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Last Name"
                                        value={claimantPersonalDetails.surname}
                                    />
                                </Grid>
                                {claimantContactDetails.telephoneNumber && (
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Telephone Number"
                                            value={claimantContactDetails.telephoneNumber}
                                        />
                                    </Grid>
                                )}

                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Cellphone"
                                        value={claimantContactDetails.cellphoneNumber}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Email Address"
                                        value={claimantContactDetails.emailAddress}
                                    />
                                </Grid>
                                {claimantPersonalDetails.companyName && (
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Company Name"
                                            value={claimantPersonalDetails.companyName}
                                        />
                                    </Grid>
                                )}
                                {claimantPersonalDetails.consultantCode && (
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label={'Broker Consultation code'}
                                            value={claimantPersonalDetails.consultantCode}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Paper>
                )}
                {claimType !== ClaimType.TerminalIllness && (
                    <Paper className={classes.paper}>
                        <Grid container justify="flex-start">
                            <Grid item xs={12} container justify="flex-start">
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="Whose details are being entered?"
                                        value={claimantDetails.whoseDetailsAreBeingEntered}
                                    />
                                </Grid>
                                {claimantDetails.whoseDetailsAreBeingEntered ===
                                    'Financial Advisor' && (
                                    <>
                                        <Grid item xs={6} md={3}>
                                            <LabeledValue
                                                label="Company Name"
                                                value={claimantDetails.companyName}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <LabeledValue
                                                label="Consultant Code"
                                                value={claimantDetails.consultantCode}
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={6} md={3}>
                                    <LabeledValue label="Title" value={title} />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="First name"
                                        value={claimantDetails.firstName}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue label="Surname" value={claimantDetails.surname} />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="Cellphone number"
                                        value={claimantDetails?.cellphoneNumber}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="Work Number"
                                        value={claimantDetails.workNumber}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="Email Address"
                                        value={claimantDetails.emailAddress}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <LabeledValue
                                        label="Preferred method of communication"
                                        value={claimantDetails.preferredMethodOfCommunication?.join(
                                            ', '
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                )}
            </React.Fragment>
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    openModal: openModalAction,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const ClaimantDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ClaimantDetailsViewComponent));
